import { Component, Input } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'app-text-rendered',
  templateUrl: './text-rendered.component.html',
  styleUrls: ['./text-rendered.component.css']
})
export class TextRenderedComponent extends ElementComponent {
  @Input() override data: any = {
    text: ''
  }

}
